import PropTypes from "prop-types";
import ComponentItem from "./ComponentItem";

const RenderItems = (props) => {
    const {items, level = 0, parentPath, root} = props;

    return (
        items.map((item, index) => {
            const path = root ? "root" : parentPath ? parentPath + `.${index}` : `children.${index}`;

            if (item.children && item.children.length) {
                return (
                    <ComponentItem
                        key={path}
                        nodeId={path}
                        component={item}
                        level={level}
                    >
                        {RenderItems({items: item.children, level: level + 1, parentPath: root ? "children" : path + '.children'})}
                    </ComponentItem>
                )
            }

            return <ComponentItem
                key={path}
                nodeId={path}
                component={item}
                level={level}
            />
        })
    )

}
export default RenderItems;

RenderItems.propTypes = {
    items: PropTypes.array,
    level: PropTypes.number,
}